import React from 'react';

const Legend = () => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ position: 'relative', height: '25px' }}>
        <div className={'dot green'} style={{ position: 'absolute', margin: '0' }} />
        <span style={{ position: 'absolute', left: '20px' }}>= Everything is approved</span>
      </div>
      <div style={{ position: 'relative', height: '25px' }}>
        <div className={'dot blue'} style={{ position: 'absolute', margin: '0' }} />
        <span style={{ position: 'absolute', left: '20px' }}>= Waiting for translations from CBG</span>
      </div>
      <div style={{ position: 'relative', height: '25px' }}>
        <div className={'dot yellow'} style={{ position: 'absolute', margin: '0' }} />
        <span style={{ position: 'absolute', left: '20px' }}>= Waiting for review</span>
      </div>
      <div style={{ position: 'relative', height: '25px' }}>
        <div className={'dot gray'} style={{ position: 'absolute', margin: '0' }} />
        <span style={{ position: 'absolute', left: '20px' }}>= Non translated locale</span>
      </div>
      <div style={{ position: 'relative', height: '25px' }}>
        <div className={'dot red'} style={{ position: 'absolute', margin: '0' }} />
        <span style={{ position: 'absolute', left: '20px' }}>= Fields are missing translation(s)</span>
      </div>
    </div>
  );
};

export default Legend;
